export default __webpack_public_path__ + "static/integrationTheme-9218009a971124343144675543ecf93b.svg";